// extracted by mini-css-extract-plugin
module.exports = {"item":"_68ed0cb5","isLegalLink":"_bebb0bf9","link":"_8da1dac0"};